{
  "version": 1,
  "asset_id": "069ef182-cfe2-430f-b2e7-cb34143ea22e",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/069ef182-cfe2-430f-b2e7-cb34143ea22e/form-656.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/069ef182-cfe2-430f-b2e7-cb34143ea22e/form-656.jpg",
  "original_filename": "form-656.jpg",
  "size": 32927,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:53Z"
}
